/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as marketService from '../../services/marketService'
import * as userService from '../../services/userService'
class UserMarketBook extends Component {
   constructor(props) {
      super(props);
      this.state = {
         userTags: [],
         userBookList: [],
         marketId: "",
         currentUser: "",
         currentUserBook: {}
      };
   }
   async componentDidMount() {
      let userData = localStorage.getItem("tokenData")
      userData = JSON.parse(userData)
      if(!(!!userData && !!userData.sub)){
         localStorage.clear();
         this.props.history.push("/auth") 
      }
      this.setState({ currentUser: userData.sub, userTags: [userData.sub], marketId: this.props.selectedMarket.marketId }, () => {
         this.loadUserBooks()
      })

   }
   async loadUserBooks() {
      let currntUser = this.state.userTags[(this.state.userTags.length - 1)]
      let data = await marketService.getUserBooks(currntUser, this.state.marketId)
      data = data.items
      this.setState({ userBookList: [] }, () => {
         this.setState({ userBookList: data })
      })
      let currentUserExpo = await userService.getUserMarketExposure(currntUser, this.state.marketId);
      currentUserExpo = currentUserExpo.items
      if (currentUserExpo && currentUserExpo.length > 0){
         this.setState({ currentUserBook: {} }, () => {
            this.setState({ currentUserBook: currentUserExpo[0] })
         })
      }
   }
   userSelect(userName) {
      let userTags = this.state.userTags
      let userIndex = userTags.indexOf(userName)
      if (userIndex === -1) {
         userTags.push(userName)
      } else {
         userTags = userTags.slice(0, userIndex + 1)
      }
      this.setState({ currentUser: userName, userTags: userTags }, () => {
         this.loadUserBooks()
      })
   }
   render() {
      let runners = this.props.selectedMarket.runners
      let currentUserBook = !!this.state.currentUserBook && !!this.state.currentUserBook.runnersExposure ? this.state.currentUserBook.runnersExposure : {}
      return (
         <>
            <div className="modal fade show" style={{ display: 'block' }} id="eventunsettle" role="dialog" aria-modal="true">
               <div className="modal-dialog modal-lg modal-dialog-scrollable">
                  <div className="modal-content">

                     <div className="modal-header">
                        <h4 className="modal-title">User Market Book - {!!this.props.selectedMarket.marketName ? this.props.selectedMarket.marketName : ""}</h4>
                        <button type="button" className="close text-white" data-dismiss="modal" onClick={() => { this.props.closeUserBook() }}>×</button>
                     </div>
                     <div className="modal-body pt-0">
                     <div className="row">
                        <div className="col-12">
                           <div style={{ padding: "10px 20px 5px" }}>
                              <span style={{ color: "black", fontSize: "18px", cursor: "pointer" }}>User : </span>
                              {this.state.userTags.map((user, i) => {
                                 return <>
                                    {user !== this.state.currentUser ?
                                       <span onClick={() => { this.userSelect(user) }} style={{ color: "blue", fontSize: "14px", cursor: "pointer" }}>{user + " > "}</span>
                                       :
                                       <span onClick={() => { this.userSelect(user) }} style={{ color: "black", fontSize: "18px", cursor: "pointer" }}>{user}</span>
                                    }
                                 </>
                              })}
                           </div>
                        </div>
                     </div>
                     <div className="row">
                        <div className="col-12">
                           <div className="table-responsive" style={{ padding: 20, paddingTop:0 }}>
                              <table id="example" className="table table-bordered font-14 tab-ttoptip whitespace">
                                 <thead>
                                    <tr>
                                       <td>No.</td>
                                       <td>User Name</td>
                                       {runners.map((rnr)=>{
                                          return <td>{rnr.name}</td>
                                       })}
                                    </tr>
                                 </thead>
                                 <tbody>
                                    {this.state.userBookList.map((usr, i) => {
                                       return (<tr>
                                          <td>{i + 1}</td>
                                          <td><a style={usr.role !== "Client" ? { color: "blue", cursor: "pointer" } : { cursor: "pointer" }} onClick={() => { if (usr.role !== "Client") { this.userSelect(usr.username) } }}>{usr.username}</a></td>
                                          {runners.map((rnr)=>{
                                             return <td>{usr.role !== "Client" ?
                                             <span style={{ float: 'right', fontWeight: "bold", color: (0 - usr.runnersExposure[rnr.id].sharingUp)<0 ? "red" : "green" }}>{Math.round(0 - usr.runnersExposure[rnr.id].sharingUp)}</span>
                                             :<span style={{ float: 'right', fontWeight: "bold", color: (0 - usr.runnersExposure[rnr.id].exposure)<0 ? "red" : "green" }}>{Math.round(0 - usr.runnersExposure[rnr.id].exposure)}</span>
                                          }</td>   
                                          })}
                                       </tr>)
                                    })}
                                    { !!currentUserBook && Object.keys(currentUserBook).length > 0 && <>
                                       <tr className="umbbgcolor font-weight-bold">
                                          <td></td>
                                          <td>Total</td>
                                          {runners.map((rnr)=>{
                                             return <td><span style={{ float: 'right', fontWeight: "bold", color: currentUserBook[rnr.id].sharingDown < 0 ? "red" : "green" }}>{Math.round(currentUserBook[rnr.id].sharingDown)}</span></td>
                                          })}
                                       </tr>
                                       <tr className="umbbgcolor font-weight-bold">
                                          <td></td>
                                          <td>Up Line</td>
                                          {runners.map((rnr)=>{
                                             return <td><span style={{ float: 'right', fontWeight: "bold", color: currentUserBook[rnr.id].sharingUp < 0 ? "red" : "green" }}>{Math.round(currentUserBook[rnr.id].sharingUp)}</span></td>
                                          })}
                                       </tr>
                                       <tr className="umbbgcolor font-weight-bold">
                                          <td></td>
                                          <td>P/L</td>
                                          {runners.map((rnr)=>{
                                             return <td><span style={{ float: 'right', fontWeight: "bold", color: currentUserBook[rnr.id].sharingMe < 0 ? "red" : "green" }}>{Math.round(currentUserBook[rnr.id].sharingMe)}</span></td>
                                          })}
                                       </tr>
                                    </>}
                                 </tbody>
                              </table>
                           </div>
                        </div>
                     </div>
                     </div>
                  </div>
               </div>
               <div className="modal-backdrop fade show" onClick={() => { this.props.closeUserBook() }}></div>
               </div>           
         </>
      )
   }
}
function mapStateToProps(state) {
   return {
   };
}
function mapDispatchToProps(dispatch) {
   return {
   };
}
export default connect(mapStateToProps, mapDispatchToProps)(UserMarketBook);